export default {
  data() {
    return {};
  },

  methods: {
    // Обработка урл;
    urlParent(value) {
      if (typeof value === 'undefined' || value === null || value === '') {
        return true;
      }
      const url = value.split('/').filter(element => element !== '').shift();
      return '/' + url + '/'
    },
    // Обработка урл;
    urlParentSub(value) {
      if (typeof value === 'undefined' || value === null || value === '') {
        return true;
      }
      if( value.slice(-1) === '/' ) {
        return value = value.substring(0, value.length - 1)+'/';
      }else{
        return value + '/'
      }
    },
  }
};



// WEBPACK FOOTER //
// ./components/shared/mixins/RouteMixin.js